import React, { createContext, useContext, useState } from 'react';
import { X } from 'lucide-react';
import {
  ToastContainer,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
} from '../../styles/toast.styles';

const ToastContext = createContext(undefined);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = (id) => {
    setToasts((prevToasts) =>
      prevToasts.map((toast) => (id === undefined || toast.id === id ? { ...toast, onOpenChange: undefined } : toast))
    );

    setTimeout(() => {
      setToasts((prevToasts) => prevToasts.filter((toast) => id === undefined || toast.id !== id));
    }, 300);
  };

  const toast = ({ title, description, variant = 'default', duration = 5000 }) => {
    const id = Math.random().toString(36).substring(2, 9);

    setToasts((prevToasts) => [{ id, title, description, variant, duration }, ...prevToasts]);

    if (duration !== Number.POSITIVE_INFINITY) {
      setTimeout(() => {
        dismiss(id);
      }, duration);
    }

    return {
      id,
      dismiss: () => dismiss(id),
    };
  };

  return (
    <ToastContext.Provider value={{ toasts, toast, dismiss }}>
      {children}
      <ToastContainer>
        {toasts.map(({ id, title, description, variant, onOpenChange }) => (
          <Toast key={id} variant={variant || 'default'}>
            <div>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            <ToastClose onClick={() => dismiss(id)}>
              <X size={16} />
            </ToastClose>
          </Toast>
        ))}
        <ToastViewport />
      </ToastContainer>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}
